import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  report: [],
  map: [],
};

export const generalSlice = createSlice({
  name: "report",
  initialState,
  reducers: {
    setReport: (state, action) => {
      state.report = action.payload;
      return state;
    },
    setMapReport: (state, action) => {
      state.map = action.payload;
      return state;
    },
  },
});

const reportReducer = generalSlice.reducer;

export const { setReport, setMapReport } = generalSlice.actions;

export default reportReducer;
